import { chain, isEmpty, join } from 'lodash';

import { DATA_SOURCE } from '../types/enums/data-source.enum';
import { TRANSFER_STATUS_VALUE } from '../types/enums/transfer-status.enum';
import { FilterStringBuilderParams } from '../types/ui/xux-grid/xux-grid.type';

export const dataSourceFilterBuilder = (
  params: FilterStringBuilderParams<string[]>,
) => {
  const { filterValue, fieldName } = params;

  const dataSourceBuilderMapping = {
    [DATA_SOURCE.Portal]: () => `${fieldName} eq null`,
    [DATA_SOURCE.POS]: () =>
      `(${fieldName} eq '${DATA_SOURCE.POS}' and status eq '${TRANSFER_STATUS_VALUE.Open}' and is_send eq true) or (${fieldName} eq '${DATA_SOURCE.POS}' and status ne '${TRANSFER_STATUS_VALUE.Open}')`,
  };

  if (isEmpty(filterValue)) {
    return join(
      [
        `${fieldName} ne '${DATA_SOURCE.POS}'`,
        dataSourceBuilderMapping[DATA_SOURCE.POS](),
      ],
      ' or ',
    );
  }

  return chain(filterValue)
    .map((value) => dataSourceBuilderMapping[value]())
    .join(' or ')
    .value();
};
